import { Link } from "react-router-dom";
import { Search, FileText } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../ui/select";
import { formatDate } from "../../lib/utils";
import { AuditBadge } from "./atoms";

export default function RecentAssessmentsCard({
  q, onQChange, auditType, onAuditTypeChange, loading, items,
}) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="p-6">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
          <h2 className="text-xl font-semibold tracking-tight text-[#0D1B2A]">Recent assessments</h2>
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <div className="relative flex-1 sm:w-72">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                value={q}
                onChange={(e) => onQChange(e.target.value)}
                placeholder="Search client, ABN, contact…"
                className="pl-9"
                data-testid="search-input"
              />
            </div>
            <Select value={auditType} onValueChange={onAuditTypeChange}>
              <SelectTrigger className="w-40" data-testid="filter-audit-type">
                <SelectValue placeholder="All types" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All types</SelectItem>
                <SelectItem value="CERTIFICATION">Certification</SelectItem>
                <SelectItem value="VERIFICATION">Verification</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        {loading && (
          <div className="text-sm text-slate-500 py-12 text-center">Loading…</div>
        )}
        {!loading && items.length === 0 && (
          <div className="py-12 text-center border border-dashed border-slate-200 rounded-md" data-testid="empty-state">
            <FileText className="w-8 h-8 text-slate-300 mx-auto mb-2" />
            <p className="text-sm text-slate-500">No assessments yet. Start a new one to begin.</p>
          </div>
        )}
        {!loading && items.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200">
                  <th className="text-left py-3 px-2">Client</th>
                  <th className="text-left py-3 px-2 hidden md:table-cell">ABN</th>
                  <th className="text-left py-3 px-2">Audit</th>
                  <th className="text-left py-3 px-2 hidden lg:table-cell">Engagement</th>
                  <th className="text-left py-3 px-2 hidden sm:table-cell">Created</th>
                  <th className="text-right py-3 px-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.id} className="border-b border-slate-100 hover:bg-slate-50"
                    data-testid={`assessment-row-${it.id}`}>
                    <td className="py-3 px-2 font-medium text-[#0D1B2A]">{it.input.org_name}</td>
                    <td className="py-3 px-2 text-slate-500 hidden md:table-cell">{it.input.abn || "—"}</td>
                    <td className="py-3 px-2"><AuditBadge type={it.result.audit_type} /></td>
                    <td className="py-3 px-2 text-slate-500 hidden lg:table-cell">{it.result.engagement_type}</td>
                    <td className="py-3 px-2 text-slate-500 hidden sm:table-cell">{formatDate(it.created_at)}</td>
                    <td className="py-3 px-2 text-right">
                      <Link to={`/assessment/${it.id}`}
                        className="text-[#1A7F6E] hover:underline font-medium"
                        data-testid={`open-assessment-${it.id}`}>
                        Open →
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
